import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";


// Translations
import enTranslation from "../lang/en.json";
import hiTranslation from "../lang/hi.json";
import guTranslation from "../lang/gu.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next) // connect with React
  .init({
    resources: {
      en: { translation: enTranslation },
      hi: { translation: hiTranslation },
      gu: { translation: guTranslation },
    },
    lng: localStorage.getItem("lng") || "en", // default language
    fallbackLng: "en",
    interpolation: { escapeValue: false },
  });

export default i18n;
